module.exports = __webpack_public_path__ + "img/ennetix-individual-network-elements-page3.74cc6bc2.png";